
import { useNavigate, useParams } from "react-router-dom";

import useJobApplicants from "@/modules/hrPortal/hooks/useJobApplicants";

import JobApplicantsHeader from "./HRJobApplicants/JobApplicantsHeader";
import JobInfoCard from "./HRJobApplicants/JobInfoCard";
import ApplicantsTable from "./HRJobApplicants/ApplicantsTable";

export default function HRJobApplicantsPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();

  const { data, loading } = useJobApplicants(jobId);

  if (loading) {
    return <div className="p-10">Loading applicants...</div>;
  }

  if (!data) {
    return <div className="p-10">No applicants found</div>;
  }

  return (
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="mx-auto max-w-7xl space-y-6">
        <JobApplicantsHeader onBack={() => navigate(-1)} />

        <JobInfoCard data={data} />

        <ApplicantsTable
          applications={data.applications}
          department={data.job?.department ?? undefined}
        />
      </div>
    </div>
  );
}
